<app-mon-compte-form [user]="user$ | async" [entite]="entite$ | async" (deconnect)="onDeconnect()"
    [isGroup]="isGroup$ | async" [isMonoSiret]="isMonoSiret$ | async"></app-mon-compte-form>